<template>
  <div style="width: 100%; height: 100%">
    <el-card style="margin: 0 auto; height: 100%">
      <div class="item-box">
        <div
          class="Home-item"
          @click="onClickAdd"
          v-if="userInfo.UserIdentity.indexOf('2') != -1"
        >
          <div class="Home-time">
            <img
              src="../../assets/add.png"
              style="width: 30px; height: 30px"
              alt=""
            />
          </div>
        </div>
        <div class="Home-item" v-for="(item, index) in list" :key="index">
          <div class="Home-time" @click.stop="onClickList(item.Id)">
            <img
              src="../../assets/list-data.png"
              style="width: 100%; height: 100%"
              alt=""
            />
            <div class="times">
              {{ item.Title }}
            </div>
            <div
              class="q-image-remover"
              @click.stop="onClickDelete(item.Id)"
              v-if="userInfo.UserIdentity.indexOf('2') != -1"
            >
              <img src="../../assets/delete-img.png" alt="" />
            </div>
            <div class="image-status" v-if="item.Status == 0">
              <img
                style="
                  width: 76px;
                  height: 76px;
                  position: absolute;
                  top: 0px;
                  left: 4px;
                "
                src="../../assets/no_complete.png"
                alt=""
              />
            </div>
          </div>
          <!-- 多选 -->
          <div
            v-if="item.Status == 1"
            class="company-item"
            :class="{ active: isChange.indexOf(item.Id) != -1 }"
            @click.stop="clickBtn(item.Id)"
          ></div>
        </div>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:0.25rem; 0 0 0"
      >
      </el-pagination>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <el-button
          :disabled="isChange.length != 0 ? false : true"
          @click="onClickPdf"
          type="primary"
        >
          预览下载
        </el-button>
      </div>
    </el-card>
    <el-dialog title="新增过程评价" :visible.sync="dialogVisible" width="30%">
      <div>
        <div class="block">
          <span class="demonstration">日期选择 </span>
          <el-date-picker
            v-model="input"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onbtnClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  FrontAddProceInfo,
  FrontGetProceListByPage,
  FrontDelProceInfo,
} from "../../api/api";
export default {
  data() {
    return {
      isChange: [], //多选
      list: [],
      dialogVisible: false,
      input: "",
      PageIndex: 1,
      PageSize: 20,
      dataInfo: {},
      userInfo: {}, //UserIdentity  0:管理员   1:园长   2:教师   3:家长
      total: 0,
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));

    this.dataInfo = JSON.parse(unescape(this.$route.query.dataInfo));
    this.GetProceListByPage();
  },

  methods: {
    onClickDelete(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          FrontDelProceInfo({ ids: [id] }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.isChange = [];
              this.GetProceListByPage();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 跳转pdf
    onClickPdf(id) {
      const href = this.$router.resolve({
        path: "/all_result",
        query: {
          Ids: JSON.stringify(this.isChange),
          type: "",
          studentId: this.dataInfo.StudentId,
          StudentName: this.dataInfo.StudentName,
        },
      });
      window.open(href.href, "_blank");
    },
    // 跳转编辑
    onClickList(Id) {
      if (this.userInfo.UserIdentity.indexOf("2") != -1) {
        let dataInfo = {
          Id: Id,
          StudentId: this.dataInfo.StudentId,
          IsBaby: this.dataInfo.IsBaby,
          BabyLevel: this.dataInfo.BabyLevel,
        };
        this.$router.push({
          path: "/editProcessEvaluate",
          query: {
            dataInfo: escape(JSON.stringify(dataInfo)),
          },
        });
      }
    },
    // 删除
    onDelete() {
      this.$confirm("是否继续此操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          FrontDelProceInfo({ ids: this.isChange }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.isChange = [];
              this.GetProceListByPage();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 获取列表
    async GetProceListByPage() {
      let xhr = await FrontGetProceListByPage({
        StudentId: this.dataInfo.StudentId,
        CycleId: this.dataInfo.CycleId,
        IsBaby: this.dataInfo.IsBaby,
        BabyLevel: this.dataInfo.BabyLevel,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      });
      if (xhr.data.success) {
        this.list = xhr.data.response.data;
        this.total = xhr.data.response.dataCount;
      } else {
        this.list = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetProceListByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetProceListByPage();
    },
    //   确定
    async onbtnClick() {
      let startData = new Date(this.input[0]);
      let endData = new Date(this.input[1]);
      const startTime =
        startData.getFullYear() +
        "/" +
        (startData.getMonth() + 1) +
        "/" +
        startData.getDate();
      const endTime =
        endData.getFullYear() +
        "/" +
        (endData.getMonth() + 1) +
        "/" +
        endData.getDate();
      this.input = `${startTime}-${endTime}`;

      FrontAddProceInfo({
        title: this.input,
        cycleId: this.dataInfo.CycleId,
        studentId: this.dataInfo.StudentId,
        isBaby: this.dataInfo.IsBaby,
        babyLevel: this.dataInfo.BabyLevel,
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.GetProceListByPage();
          this.dialogVisible = false;
        }
        //console.log(res);
      });
    },
    //   添加
    onClickAdd() {
      this.dialogVisible = true;
    },
    clickBtn(index) {
      // 多选
      if (this.isChange.indexOf(index) == -1) {
        if (this.isChange.length == 4) {
          this.$message({
            type: "error",
            message: "最多选择四个",
          });
        } else {
          this.isChange.push(index); //选中添加到数组里
        }
      } else {
        this.isChange.splice(this.isChange.indexOf(index), 1); //取消选中
      }
      let list2 = [];
      for (let index in this.isChange) {
        list2.push(this.list[this.isChange[index]]);
      }
    },
  },
};
</script>

<style scoped lang="less">
.q-image-remover {
  width: 0;
  height: 0;
  border-top: 66px solid #bfde85;
  border-left: 66px solid transparent;
  position: absolute;
  top: 0;
  right: 0;
  img {
    width: 24px;
    height: 24px;
    position: absolute;
    top: -60px;
    right: 4px;
  }
}
.onClickCompound {
  width: 290px;
  height: 50px;
  background: #4cbff4;
  border-radius: 10px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  /*消除button的默认样式*/
  /*这种写法是对所有的button标签同时生效*/
  margin: 0px;
  padding: 0px;
  /*自定义边框*/
  border: 0px;
  /*消除默认点击蓝色边框效果*/
  outline: none;
}
.el-input {
  width: 357px;
  height: 42px;
  background: #ffffff;
}
.company-item {
  width: 25px;
  height: 25px;
  background: url(../../assets/duoxuan.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 20px;
}
.active {
  background: url(../../assets/duoxuan-activite.png) no-repeat;
  background-size: 100% 100%;
}
.item-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  .Home-item {
    display: flex;
    align-items: center;
    margin: 10px;
    flex-direction: column;
    position: relative;
    background: #ffffff;
    .Home-time {
      position: relative;
      width: 158px;
      height: 220px;
      border: 1px solid #333333;
      color: #000;
      font-size: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      text-align: center;
      .times {
        width: 100%;
        height: 50px;
        background: rgba(52, 52, 52, 0.3);
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        color: #000;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        text-align: center;
      }
    }
  }
}
</style>